export default "__VITE_ASSET__7b3032bc__"